import { useDayjs } from '@/composables/DayJs.js';

const formatShortDate = dateString => {
  if (!dateString) {
    return null;
  }

  const dayJs = useDayjs();

  return dayJs(dateString).format('DD MMM YYYY');
};

const formatShortDateAndTime = dateString => {
  if (!dateString) {
    return null;
  }

  const dayJs = useDayjs();

  return dayJs(dateString).format('DD MMM YYYY, HH:mm');
};

const formatFromNow = dateString => {
  if (!dateString) {
    return null;
  }

  const dayJs = useDayjs();

  return dayJs(dateString).fromNow();
};

const formatFullDate = dateString => {
  if (!dateString) {
    return null;
  }

  const dayJs = useDayjs();

  return dayJs(dateString).format('dddd, D MMMM');
};

export const useDateFormatter = () => {
  return {
    formatShortDate,
    formatShortDateAndTime,
    formatFromNow,
    formatFullDate,
  };
};
